import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type PreloaderVariant = 'card' | 'inline';

@Component({
  selector: 'app-preloader',
  standalone: true,
  templateUrl: './preloader.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.flex]': "variant() === 'card'",
    '[class.flex-1]': "variant() === 'card'",
    '[class.items-center]': "variant() === 'card'",
    '[class.justify-center]': "variant() === 'card'",
    '[class.w-full]': "variant() === 'card'",
    '[class.min-h-0]': "variant() === 'card'",
  },
})
export class Preloader {
  readonly message = input.required<string>();
  readonly variant = input<PreloaderVariant>('card');
}
